"use client";

import { setCookieConsent } from "@/lib/cookie-consent";

/**
 * Riporta il consenso a "nessuna scelta": fa ricomparire il banner, così chi
 * ha già risposto può cambiare idea senza dover svuotare la cache a mano.
 */
export function CookiePreferencesLink({ label, className }: { label: string; className?: string }) {
  return (
    <button type="button" onClick={() => setCookieConsent(null)} className={className}>
      {label}
    </button>
  );
}
